// Re-exports the shared ChangePasswordDialog in admin mode.
import SharedDialog from '@/components/ui/change-password-dialog';

function ChangePasswordDialog({ open, onOpenChange, repid, onSuccess }) {
    return (
        <SharedDialog
            open={open}
            onOpenChange={onOpenChange}
            mode="admin"
            repid={repid}
            onSuccess={onSuccess}
        />
    );
}

export default ChangePasswordDialog;
